export const SELECTOR_BAR_STYLES = {
  container: 'rounded-lg border border-border bg-surface-secondary p-1 shadow-inner',
  buttonBase: 'focus-visible:outline-none focus-visible:ring-0',
  buttonActive: 'bg-surface text-text-primary border border-border',
  buttonInactive: 'bg-transparent text-text-secondary hover:text-text-primary border border-transparent'
} as const
